import type { ProductTabRoute } from '@hopdrive/feature-portal-products';

import { appendSearch } from '@utils/appendSearch';

/**
 * The embed's tab paths, carrying the current query string.
 *
 * Every embed knob is URL-only — the hash session itself, `rooftopId`, `readOnly`, the branding
 * params — so a tab click that navigated to the bare tab path would drop the integrator's whole
 * configuration on the first tab change. `ProductShellLayout` navigates to `tabPath(tabs, key)`,
 * which is the tab's `path` verbatim, so appending the search here is what makes the knobs
 * survive (decision S7 / C20).
 *
 * The clean path moves into `matches`, which `resolveActiveTabKey` also consults, so the active
 * tab still resolves from the pathname (a pathname never contains the query string). A tab path
 * that carries its own query gets the search joined on with `&`.
 */
export const withSearchParams = (tabs: ProductTabRoute[], search: string): ProductTabRoute[] =>
  search
    ? tabs.map(tab => ({ ...tab, path: appendSearch(tab.path, search), matches: [tab.path, ...(tab.matches ?? [])] }))
    : tabs;
